import styled from "styled-components";
import checked from "../../../assets/checked.svg";

export const Container = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "orientation",
})`
	display: flex;
	justify-content: center;
	flex-direction: ${({ orientation }) => (orientation === "left" ? "row" : "row-reverse")};
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
`;

export const InputCheckBox = styled.input`
	cursor: pointer;
	appearance: none;
	color: var(--brand-primary);
	width: 18px;
	min-width: 18px;
	height: 18px;
	min-height: 18px;
	border: 0.15em solid var(--brand-primary);
	border-radius: 0.15em;

	&:checked {
		background-image: url(${checked});
		background-position: center;
		background-size: auto;
		border: none;
	}
`;

export const Label = styled.label`
	font-size: var(--font-size-default);
	color: var(--neutral-smoothest);
	cursor: pointer;
`;
